module.exports = __webpack_public_path__ + "img/69ne.13e431e6.svg";